import { Component } from '@angular/core';

@Component({
  selector: 'app-story',
  templateUrl: './story.component.html'
})
export class StoryComponent {}
